import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";

export const DrawerProduceWrapperStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "drawer-produce-wrapper",
})`
  position: relative;
  padding-inline-end: 48px;
  padding-block-end: 24px;
`;
